module.exports = __webpack_public_path__ + "static/media/green-check.7b1b01b7.svg";